<template>
  <div style="height: 45vh">
    <!-- Row for Label type -->
    <el-row style="font-size: 0.9em; height: 4vh; align-items: center;">
      <el-col :span="1"></el-col>
      <el-col :span="3" style="display: flex; align-items: center;">
        <p style="margin: 0; line-height: normal;">Label type</p>
      </el-col>
      <el-col :span="2"></el-col>
      <el-col :span="16">
        <el-radio-group v-model="localNodeType" @change="handleNodeTypeChange" class="radio-row">
          <el-row>
            <el-radio value="1" size="small" style="width: 8vw;">Keep node size same</el-radio>
            <el-radio value="2" size="small" style="width: 15vw;">Set node size proportional to edge numbers</el-radio>
          </el-row>
        </el-radio-group>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>

    <el-row style="font-size: 0.9em; height: 4vh; align-items: center;">
      <el-col :span="1"></el-col>
      <el-col :span="3" style="display: flex; align-items: center;">
        <p style="margin: 0; line-height: normal;">Node name</p>
      </el-col>
      <el-col :span="2"></el-col>
      <el-col :span="16">
        <el-radio-group v-model="localNodeNameType" @change="handleNodeNameTypeChange" class="radio-row">
          <el-row>
            <el-radio value="1" size="small" style="width: 7vw;">EXID</el-radio>
            <el-radio value="2" size="small" style="width: 10vw;">Preferred name</el-radio>
            <el-radio value="3" size="small" style="width: 7vw;">No name</el-radio>
          </el-row>
        </el-radio-group>
      </el-col>
      <el-col :span="1"></el-col>
    </el-row>
    <!-- Reusable Slider Component -->
    <template v-for="(item, index) in sliderConfigs" :key="index">
      <el-row class="row-style">
        <el-col :span="1"></el-col>
        <el-col :span="3"><span class="row-title nowrap-text">{{ item.label }}</span></el-col>
        <el-col :span="2"></el-col>
        <el-col :span="16">
          <el-row>
            <el-col :span="3"><p class="min-max-label">Min</p></el-col>
            <el-col :span="2"></el-col>
            <el-col :span="14">
              <el-slider 
                :model-value="item.label === 'Node size' ? localNodeSize : 
                             item.label === 'Line width' ? localLineWidth : 
                             item.label === 'Node transparency' ? localNodeTransparency :
                             item.label === 'Line transparency' ? localLineTransparency :
                             item.label === 'Label size' ? networkLabelSize :
                             item.value"
                @update:model-value="(val) => {
                  if (item.label === 'Node size') {
                    handleNodeSizeChange(val);
                  } else if (item.label === 'Line width') {
                    handleLineWidthChange(val);
                  } else if (item.label === 'Node transparency') {
                    handleNodeTransparencyChange(val);
                  } else if (item.label === 'Line transparency') {
                    handleLineTransparencyChange(val);
                  } else if (item.label === 'Label size') {
                    handleLabelSizeChange(val);
                  } else {
                    item.value = val;
                  }
                }"
                :max="item.max" 
                :step="item.step || 1"
              />
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="3"><p class="min-max-label">Max</p></el-col>
          </el-row>
        </el-col>
        <el-col :span="1"></el-col>
      </el-row>
    </template>

    <!-- Row for Line color -->
    <el-row class="row-style">
      <el-col :span="1"></el-col>
      <el-col :span="3"><p class="row-title">Line color</p></el-col>
      <el-col :span="2"></el-col>
      <el-col :span="18">
        <el-color-picker v-model="localLineColor" />
      </el-col>
    </el-row>

    <!-- Row for Node color -->
    <el-row :style="`font-size: 0.9em; height: ${Math.ceil(nodeGroups.length / 3) * 4}vh`">
      <el-col :span="1"></el-col>
      <el-col :span="3"><p class="row-title">Node color</p></el-col>
      <el-col :span="2"></el-col>
      <el-col :span="18">
        <el-row>
          <el-col :span="8" v-for="(group, index) in nodeGroups" :key="index">
            <el-row>
              <el-col :span="5">
                <el-color-picker v-model="nodeColors[group]" @change="(val) => handleNodeColorChange(val, group)" />
              </el-col>
              <el-col :span="19">
                <p class="category-label">{{ group }}</p>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: "ConfigsView",
  computed: {
    ...mapState(['nodeNameType', 'nodeType', 'nodeSize', 'lineWidth', 'nodeTransparency', 'lineTransparency', 'lineColor', 'networkLabelSize']),
    localNodeNameType: {
      get() {
        return this.nodeNameType;
      },
      set(value) {
        this.handleNodeNameTypeChange(value);
      }
    },
    localNodeType: {
      get() {
        return this.nodeType;
      },
      set(value) {
        this.handleNodeTypeChange(value);
      }
    },
    localNodeSize: {
      get() {
        return this.nodeSize;
      },
      set(value) {
        this.handleNodeSizeChange(value);
      }
    },
    localLineWidth: {
      get() {
        return this.lineWidth;
      },
      set(value) {
        this.handleLineWidthChange(value);
      }
    },
    localNodeTransparency: {
      get() {
        return this.nodeTransparency;
      },
      set(value) {
        this.handleNodeTransparencyChange(value);
      }
    },
    localLineTransparency: {
      get() {
        return this.lineTransparency;
      },
      set(value) {
        this.handleLineTransparencyChange(value);
      }
    },
    localLineColor: {
      get() {
        return this.lineColor;
      },
      set(value) {
        this.handleLineColorChange(value);
      }
    },
    localLabelSize: {
      get() {
        return this.networkLabelSize;
      },
      set(value) {
        this.handleLabelSizeChange(value);
      }
    }
  },
  methods: {
    ...mapMutations(['SET_NODE_NAME_TYPE', 'SET_NODE_TYPE', 'SET_NODE_SIZE', 'SET_LINE_WIDTH', 'SET_NODE_TRANSPARENCY', 'SET_LINE_TRANSPARENCY', 'SET_LINE_COLOR', 'SET_NETWORK_LABEL_SIZE']),
    handleNodeNameTypeChange(value) {
      this.SET_NODE_NAME_TYPE(value);
      this.$emit('network-update', {
        type: 'nameType',
        nameType: value
      });
    },
    handleNodeTypeChange(value) {
      this.SET_NODE_TYPE(value);
      this.$emit('network-update', {
        type: 'nodeType',
        nodeType: value
      });
    },
    handleNodeSizeChange(value) {
      this.SET_NODE_SIZE(value);
      this.$emit('network-update', {
        type: 'size',
        size: value
      });
    },
    handleLineWidthChange(value) {
      this.SET_LINE_WIDTH(value);
      this.$emit('network-update', {
        type: 'lineWidth',
        lineWidth: value
      });
    },
    handleNodeTransparencyChange(value) {
      this.SET_NODE_TRANSPARENCY(value);
      this.$emit('network-update', {
        type: 'nodeTransparency',
        nodeTransparency: value
      });
    },
    handleLineTransparencyChange(value) {
      this.SET_LINE_TRANSPARENCY(value);
      this.$emit('network-update', {
        type: 'lineTransparency',
        lineTransparency: value
      });
    },
    handleLineColorChange(value) {
      this.SET_LINE_COLOR(value);
      this.$emit('network-update', {
        type: 'lineColor',
        lineColor: value
      });
    },
    handleNodeColorChange(color, group) {
      this.nodeColors[group] = color;
      this.$emit('network-update', {
        type: 'nodeColor',
        nodeColors: this.nodeColors
      });
    },
    handleLabelSizeChange(value) {
      this.SET_NETWORK_LABEL_SIZE(value);
      this.$emit('network-update', {
        type: 'labelSize',
        size: value
      });
    },
    updateNodeGroups() {
      // 从父组件获取节点列表
      const nodeList = this.$parent.nodeList;
      if (nodeList && nodeList.length > 0) {
        // 获取所有唯一的组
        const groups = [...new Set(nodeList.map(node => node.group))];
        this.nodeGroups = groups;
        
        // 为每个组设置默认颜色
        groups.forEach(group => {
          if (!this.nodeColors[group]) {
            this.nodeColors[group] = '#5470c6';
          }
        });
      }
    }
  },
  data() {
    return {
      nodeColors: {}, // 存储每个组的颜色
      nodeGroups: [], // 存储所有节点组
      sliderConfigs: [
        { label: "Node size", value: 10, max: 20 },
        { label: "Line width", value: 1, max: 20 },
        { label: "Label size", value: 10, max: 20, step: 1 },
        { label: "Node transparency", value: 50, max: 100 },
        { label: "Line transparency", value: 100, max: 100 },
      ],
    };
  },
  created() {
    // 设置初始值
    this.sliderConfigs[0].value = this.nodeSize;
    this.sliderConfigs[1].value = this.lineWidth;
    this.sliderConfigs[3].value = this.nodeTransparency;
    this.sliderConfigs[4].value = this.lineTransparency;
  },
  mounted() {
    // 在组件挂载后获取节点组信息
    this.updateNodeGroups();
  },
  watch: {
    // 监听父组件的 nodeList 变化
    '$parent.nodeList': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.updateNodeGroups();
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.row-style {
  font-size: 0.9em;
  height: 4vh;
}
.row-title {
  margin-top: 5px;
  float: left;
}
.radio-row .radio-option {
  width: auto;
  margin-right: 10px;
}
.radio-row .el-radio {
  margin-right: 20px;
  margin-bottom: 2px;
  display: inline-block;
}
.radio-row .el-radio__label {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
  font-size: 0.85em;
}
.min-max-label {
  margin-top: 5px;
  float: left;
}
.nowrap-text {
  white-space: nowrap;
}
.category-label {
  margin-top: 5px;
  float: left;
}
</style>

